import type { ThemeConfig } from 'antd';

export const PRIMARY_COLOR = '#000000';

export const globalTheme: ThemeConfig = {
  token: {
    colorPrimary: PRIMARY_COLOR,
    fontFamily: 'Lufga',
    borderRadius: 6,
    colorError: '#ff4d4f',
    colorSuccess: '#52c41a',
    colorWarning: '#faad14',
    colorInfo: PRIMARY_COLOR,
    colorLink: '#525355',
    colorLinkHover: PRIMARY_COLOR,
    colorLinkActive: PRIMARY_COLOR,
    colorTextBase: '#525355',
    colorBgContainer: '#ffffff',
    colorBorder: '#d9d9d9',
    fontSize: 14,
    controlHeight: 32,
  },
  components: {
    Button: {
      borderRadius: 6,
      algorithm: true,
      linkHoverBg: 'transparent',
      colorLink: PRIMARY_COLOR,
      colorLinkHover: PRIMARY_COLOR,
      colorLinkActive: PRIMARY_COLOR,
      boxShadow: 'none',
      primaryShadow: 'none',
      lineWidthFocus: 0,
    },
    Alert: {
      colorInfoBg: '#f7f7f7',
      colorInfoBorder: '#d9d9d9',
    },
    Input: {
      controlHeight: 35,
      paddingInline: 12,
    },
    Select: {
      controlHeight: 35,
    },
    Segmented: {
      borderRadius: 24,
      borderRadiusXS: 24,
      borderRadiusSM: 24,
      borderRadiusLG: 24,
      itemSelectedBg: '#ffffff',
      itemSelectedColor: '#525355',
      controlHeight: 40,
    },
    Menu: {
      itemBg: '#FAFAFA',
      itemSelectedBg: 'rgba(0, 0, 0, 0.06)',
      subMenuItemBg: 'transparent',
      lineWidth: 0,
      activeBarBorderWidth: 0,
      itemHoverColor: '#000',
    },
    Layout: {
      headerBg: '#FAFAFA',
      bodyBg: '#FAFAFA',
      siderBg: '#FAFAFA',
      headerPadding: '0 24px',
    },
    Upload: {
      actionsColor: '#525355',
    },
    Form: {
      labelColor: '#525355',
      colorError: '#ff4d4f',
    },
    Tabs: {
      inkBarColor: PRIMARY_COLOR,
      itemHoverColor: PRIMARY_COLOR,
      itemSelectedColor: PRIMARY_COLOR,
      itemActiveColor: PRIMARY_COLOR,
      lineWidthFocus: 0,
    },
    Cascader: {
      dropdownHeight: 360,
    },
    Steps: {
      colorPrimary: PRIMARY_COLOR,
      algorithm: true,
    },
    Statistic: {
      contentFontSize: 20,
    },
    Checkbox: {
      borderRadius: 2,
    },
    Modal: {
      fontFamily: 'Lufga',
    },
    Notification: {
      fontFamily: 'Lufga',
    },
    Message: {
      fontFamily: 'Lufga',
    },
  },
};
